import { render, staticRenderFns } from "./AnlingChaiLing.vue?vue&type=template&id=453feca1&scoped=true&"
import script from "./AnlingChaiLing.vue?vue&type=script&lang=js&"
export * from "./AnlingChaiLing.vue?vue&type=script&lang=js&"
import style0 from "./AnlingChaiLing.vue?vue&type=style&index=0&id=453feca1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453feca1",
  null
  
)

export default component.exports